import React, { useState } from "react";

import {
    FacebookShareButton,
    TwitterShareButton,
    EmailShareButton,
    WhatsappShareButton,
    LinkedinShareButton,
} from "react-share";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import EmailIcon from '@mui/icons-material/Email';
import Typography from "@mui/material/Typography";
import { useDispatch, useSelector } from "react-redux";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded';

import slugify from "react-slugify";
import { TwitterIcon } from "../Icons";
import { WEB_URL } from "../../api/URLs";
import { S3_BUCKET } from "../../constants";
import { ModalLayout } from "./BigModalLayout";
import { MixPanelTrackedLink, Textfield } from "..";
import Tracking from "../../services/tracking.service";
import { fundRaiserPageAction } from "../../store/actions";
import { useNonInitialEffect } from "../../hooks/UseNonInitialEffect";
import { StyledShareFundraiserModal } from "./styles/ShareFundraiserStyles";
import { ContentForBackToSchoolCampaign } from "./EmailContentForCampaigns";

export function ShareFundraiserModal({ openModal, setOpenModal }) {

    const dispatch = useDispatch();
    const [buttonText, setButtonText] = useState('Copy');
    const pageDetails = useSelector(state => state.fundraiser_page.fundraiser_details);

    // const shareUrl = `${process.env.REACT_APP_URL}/fundraiser/${pageDetails.event_id + '/' + slugify(pageDetails.page_title)}`;
    const shareUrl = `${process.env.REACT_APP_URL}${WEB_URL.FUNDRAISER_DETAILS(pageDetails.event_id, slugify(pageDetails.page_title))}`;
    const shareTitle = pageDetails.page_title;
    const fbCoverImage = pageDetails.cover_image ? S3_BUCKET + pageDetails.cover_image : "";
    let emailBody = null;
    let emailSubject = null;
    if (pageDetails.campaign_name == "TCF Canada's Literacy Challenge") {
        emailBody = `Hello,

I am excited to share that I am participating in TCF Canada’s Literacy Challenge! As part of the challenge, I will be spending six hours on Sunday, April 8th in the proverbial shoes of an illiterate person by giving up my ability to read or write – no texts, no social media, no email or even Google Maps!
        
I signed up for the challenge because literacy is a human right and TCF Canada is a the forefront of providing quality education for the underprivileged; being ranked a Top 10 Impact Charity by Charity Intelligence Canada for three years running. Over the course of 30 days, the campaign aims to raise ~$630,000, which is enough to educate ~3,500 children for a year! Personally, I have committed to raising ${pageDetails.symbol_left} ${pageDetails.fundraising_goal} as part of ${pageDetails.page_title}. I hope you will consider making a donation and helping me spread the word about this Challenge!
        
Here is the link to the fundraising page:
        
${shareUrl}
        
With gratitude,
        
${pageDetails.first_name} ${pageDetails.last_name}`;

        emailSubject = `Please support ${shareTitle} in raising funds for the The Literacy Challenge!`
    }

    else if(pageDetails.campaign_name == "TCF Canada's Back-to-School Literacy Challenge") {
        emailSubject = `Please support ${shareTitle} in raising funds for the The Literacy Challenge!`
        emailBody = ContentForBackToSchoolCampaign(shareUrl,`${pageDetails.first_name} ${pageDetails.last_name}`, `${pageDetails.symbol_left} ${pageDetails.fundraising_goal}`, pageDetails.page_title)
    }
    else {
        emailBody = `Hello,

I thought you might be interested in supporting this Fundraiser, ${shareUrl}.
        
Even a small donation could help ${pageDetails.first_name} ${pageDetails.last_name} reach their fundraising goal. And if you can't make a donation, it would be great if you could share the fundraiser to help spread the word.
        
Thanks for taking a look!`;

        emailSubject = `Have you seen "${shareTitle}"`
    }

    const handleShareClick = (medium) => {
        let payload = {
            fundraiser_page_id: pageDetails.id,
            network: medium
        };

        Tracking.trackLink(medium, "button", "Social media share icon on share fundraiser modal");

        dispatch(fundRaiserPageAction.addSocialCount(payload));
    }

    const copyToClipboard = (url) => {
        let textField = document.createElement('textarea');
        textField.innerText = url;
        document.body.appendChild(textField);
        textField.select();
        document.execCommand('copy');
        textField.remove();
        setButtonText('Copied!');
    }

    useNonInitialEffect(() => {
        if (!openModal) {
            setButtonText('Copy');
            dispatch(fundRaiserPageAction.getSocialCount(pageDetails.id));
        }
    }, [openModal])

    return (
        <ModalLayout
            open={openModal}
            title="Share your fundraiser"
            setOpen={setOpenModal}
        >
            <StyledShareFundraiserModal>
                <Typography align="center" sx={{ mb: 4 }}>Fundraisers shared on social networks<br />raise up to five times more.</Typography>
                <Stack className="IconsStack">
                    <FacebookShareButton url={shareUrl} imageUrl={fbCoverImage} onClick={() => { handleShareClick('facebook') }}>
                        <FacebookRoundedIcon sx={{ color: '#1E4FAD' }} fontSize="large" />
                        <Typography variant="small">Facebook</Typography>
                    </FacebookShareButton>

                    <TwitterShareButton url={shareUrl} title={shareTitle} onClick={() => { handleShareClick('twitter') }}>
                        <TwitterIcon width={35} />
                        <Typography variant="small">X.com</Typography>
                    </TwitterShareButton>

                    <EmailShareButton url={''} title={shareTitle} subject={emailSubject} body={emailBody} openShareDialogOnClick={true} onClick={() => { handleShareClick('email') }} className="">
                        <EmailIcon  sx={{ color: '#B3B8B9' }} fontSize="large" />
                        <Typography variant="small">Email</Typography>
                    </EmailShareButton>

                    <WhatsappShareButton url={shareUrl} title={shareTitle} onClick={() => { handleShareClick('whatsapp') }} className="">
                        <WhatsAppIcon  sx={{ color: '#0B8F21' }} fontSize="large" />
                        <Typography variant="small">WhatsApp</Typography>
                    </WhatsappShareButton>

                    <LinkedinShareButton url={shareUrl} title={shareTitle} onClick={() => { handleShareClick('linkedin') }} className="">
                        <LinkedInIcon  sx={{ color: '#007AB5' }} fontSize="large" />
                        <Typography variant="small">LinkedIn</Typography>
                    </LinkedinShareButton>
                </Stack>
                <Divider sx={{ mt: 4, mb: 4 }} />
                <Stack className="CopyUrlStack">
                    <Textfield
                        id="myid"
                        name="myid"
                        label="Copy Link"
                        value={shareUrl}
                        readOnly
                        fullWidth
                    />
                    <Box>
                        <MixPanelTrackedLink
                            tabindex="3"
                            type="button"
                            size="small"
                            label="Copy"
                            variant="outlined"
                            disabled={buttonText == "Copied!"}
                            onClick={() => { copyToClipboard(shareUrl) }}
                            context={`Copied fundraiser url of ${shareUrl}`}
                        >
                            {buttonText}
                        </MixPanelTrackedLink>
                    </Box>
                </Stack>
            </StyledShareFundraiserModal>
        </ModalLayout>
    )
}